import {
  FETCH_CERTIFICATES_REQUEST,
  FETCH_CERTIFICATES_SUCCESS,
  FETCH_CERTIFICATES_FAILURE,
  FETCH_CERTIFICATE_DETAIL_REQUEST,
  FETCH_CERTIFICATE_DETAIL_SUCCESS,
  FETCH_CERTIFICATE_DETAIL_FAILURE,
  CREATE_CERTIFICATE_REQUEST,
  CREATE_CERTIFICATE_SUCCESS,
  CREATE_CERTIFICATE_FAILURE,
  DELETE_CERTIFICATES_BY_TASK_REQUEST,
  DELETE_CERTIFICATES_BY_TASK_SUCCESS,
  DELETE_CERTIFICATES_BY_TASK_FAILURE,
  CHECK_CERTIFICATE_PURCHASE_STATUS_REQUEST,
  CHECK_CERTIFICATE_PURCHASE_STATUS_SUCCESS,
  CHECK_CERTIFICATE_PURCHASE_STATUS_FAILURE,
  MARK_CERTIFICATE_PURCHASED_REQUEST,
  MARK_CERTIFICATE_PURCHASED_SUCCESS,
  MARK_CERTIFICATE_PURCHASED_FAILURE,
} from '../types/certificateTypes';

import {
  listCertificatesAdmin,
  getCertificateAdminDetail,
  createCertificateAdmin,
  deleteCertificatesAdminByTask,
  getCertificatePurchaseStatus,
  markCertificatePurchased,
} from '../../services/certificatesApi';

export const fetchCertificates = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CERTIFICATES_REQUEST });
    try {
      const response = await listCertificatesAdmin(params);
      if (response.data?.success) {
        dispatch({ type: FETCH_CERTIFICATES_SUCCESS, payload: response.data.data });
      } else {
        dispatch({
          type: FETCH_CERTIFICATES_FAILURE,
          payload: response.data?.message || 'Failed to fetch certificates',
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CERTIFICATES_FAILURE,
        payload: error.response?.data?.message || 'Failed to fetch certificates',
      });
    }
  };
};

export const fetchCertificateDetail = (id) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CERTIFICATE_DETAIL_REQUEST });
    try {
      const response = await getCertificateAdminDetail(id);
      if (response.data?.success) {
        dispatch({ type: FETCH_CERTIFICATE_DETAIL_SUCCESS, payload: response.data.data });
      } else {
        dispatch({
          type: FETCH_CERTIFICATE_DETAIL_FAILURE,
          payload: response.data?.message || 'Failed to fetch certificate detail',
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CERTIFICATE_DETAIL_FAILURE,
        payload: error.response?.data?.message || 'Failed to fetch certificate detail',
      });
    }
  };
};

export const createCertificate = (payload) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_CERTIFICATE_REQUEST });
    try {
      const response = await createCertificateAdmin(payload);
      if (response.data?.success) {
        dispatch({ type: CREATE_CERTIFICATE_SUCCESS, payload: response.data.data });
        return { ok: true, data: response.data.data };
      }
      const message = response.data?.message || 'Failed to create certificate';
      dispatch({ type: CREATE_CERTIFICATE_FAILURE, payload: message });
      return { ok: false, message };
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to create certificate';
      dispatch({ type: CREATE_CERTIFICATE_FAILURE, payload: message });
      return { ok: false, message };
    }
  };
};

export const deleteCertificatesByTask = (taskId) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CERTIFICATES_BY_TASK_REQUEST });
    try {
      const response = await deleteCertificatesAdminByTask(taskId);
      if (response.data?.success) {
        dispatch({ type: DELETE_CERTIFICATES_BY_TASK_SUCCESS, payload: response.data.data });
        return { ok: true, data: response.data.data };
      }
      const message = response.data?.message || 'Failed to delete certificates by task';
      dispatch({ type: DELETE_CERTIFICATES_BY_TASK_FAILURE, payload: message });
      return { ok: false, message };
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to delete certificates by task';
      dispatch({ type: DELETE_CERTIFICATES_BY_TASK_FAILURE, payload: message });
      return { ok: false, message };
    }
  };
};

export const checkCertificatePurchaseStatus = (taskId) => {
  return async (dispatch) => {
    dispatch({ type: CHECK_CERTIFICATE_PURCHASE_STATUS_REQUEST });
    try {
      const response = await getCertificatePurchaseStatus(taskId);
      if (response.data?.success) {
        dispatch({ type: CHECK_CERTIFICATE_PURCHASE_STATUS_SUCCESS, payload: response.data.data });
        return { ok: true, data: response.data.data };
      }
      const message = response.data?.message || 'Failed to check purchase status';
      dispatch({ type: CHECK_CERTIFICATE_PURCHASE_STATUS_FAILURE, payload: message });
      return { ok: false, message };
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to check purchase status';
      dispatch({ type: CHECK_CERTIFICATE_PURCHASE_STATUS_FAILURE, payload: message });
      return { ok: false, message };
    }
  };
};

export const markTaskCertificatePurchased = (payload) => {
  return async (dispatch) => {
    dispatch({ type: MARK_CERTIFICATE_PURCHASED_REQUEST });
    try {
      const response = await markCertificatePurchased(payload);
      if (response.data?.success) {
        dispatch({ type: MARK_CERTIFICATE_PURCHASED_SUCCESS, payload: response.data.data });
        return { ok: true, data: response.data.data, message: response.data?.message };
      }
      const message = response.data?.message || 'Failed to mark certificate purchased';
      dispatch({ type: MARK_CERTIFICATE_PURCHASED_FAILURE, payload: message });
      return { ok: false, message };
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to mark certificate purchased';
      dispatch({ type: MARK_CERTIFICATE_PURCHASED_FAILURE, payload: message });
      return { ok: false, message };
    }
  };
};

